import { message } from 'antd';
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useLocation, useHistory } from 'react-router-dom';
import KeepAlive from 'react-activation';
import styles from './SearchResult.module.less';
import SearchTab from './SearchTab';
import SearchSoft from './SearchSoft';
import SearchWallpaper from './SearchWallpaper';
import SearchPost from './SearchPost';
import SearchCourse from './SearchCourse';
import ScrollTop from '../../components/ScrollTop/ScrollTop';

import { logging, logPostInfo } from '../../actions/log';
import { updateSearchParam } from '../../actions/searchResult';

import { getQueryString } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectSearchResultObj = createSelector(
  state => state.searchResult,
  searchResult => searchResult,
);

function SearchResult() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { searchParam } = useSelector(selectSearchResultObj);

  const [scrollNode, setScrollNode] = useState(null);

  useEffect(() => {
    let nowSearchWords = getQueryString('keyword');
    if (logInfoData?.search_word !== nowSearchWords) {
      dispatch(
        logPostInfo({
          ...logInfoData,
          search_word: nowSearchWords,
        }),
      );
    }
  }, [location]);

  // 浏览时长打桩
  const leaveTimeLog = useCallback(
    initTime => {
      const keyword = getQueryString('keyword');
      const firstId = getQueryString('firstId');
      const androidType = getQueryString('androidType');
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time_Mian',
          label: '',
          param2: {
            source: `Search`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word || keyword,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            keyword,
            firstId,
            androidType,
            ...searchParam,
          },
        }),
      );
    },
    [logInfoData, searchParam],
  );

  // 统计页面浏览时长
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      leaveTimeLog(initTime);
    };
  }, []);

  useEffect(() => {
    const keyword = getQueryString('keyword');
    const activeTab = getQueryString('activeTab') || 'soft';
    // const filetype = getQueryString('filetype') ?? '';
    // const type = getQueryString('type') ?? '';
    dispatch(
      logging({
        category: 'P',
        action: 'Search',
        label: '',
        param2: {
          source: 'Search',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word || keyword,
          keyword,
          activeTab,
          // filetype,
          // type,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Search',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, []);

  /**
   * 搜索页面由于筛选条件过多，所以选择使用redux中的数据来存储参数。
   * searchMode: 0直接搜索   1条件筛选   搜索页面因为点击搜索按钮的搜索和条件筛选搜索参数searchMode不同
   */
  useEffect(() => {
    const keyword = getQueryString('keyword');
    const activeTab = getQueryString('activeTab') || 'soft';
    // 如果搜索词无变化，则不重置搜索参数，并且从而使用redux中的数据渲染
    // 如果有变化则重置搜索参数，起始参数开始搜索
    if (keyword && searchParam?.searchWord !== keyword) {
      let param = {
        searchWord: keyword,
        searchMode: '0',
        activeTab: activeTab,
        sortTypeSel: '0',
        softCategorySel: '0',
        wallpaperDpiSel: '0',
        wallpaperPaySel: '0',
        postTypeSel: '0',
        coursePaySel: '0',
      };
      dispatch(updateSearchParam(param));
    }
  }, [searchParam, history, location]);

  return (
    <div className={styles.page} ref={r => setScrollNode(r)} pagescroll="PCStore_Page_Scroll">
      <div className={styles.page_container}>
        <SearchTab />
        {searchParam.activeTab === 'soft' && <SearchSoft scrollNode={scrollNode} />}
        {searchParam.activeTab === 'wallpaper' && <SearchWallpaper scrollNode={scrollNode} />}
        {searchParam.activeTab === 'post' && <SearchPost scrollNode={scrollNode} />}
        {searchParam.activeTab === 'course' && <SearchCourse scrollNode={scrollNode} />}
        <ScrollTop node={scrollNode} quickly={true} />
      </div>
    </div>
  );
}

export default () => (
  <KeepAlive name="searchresult" id="searchresult">
    <SearchResult />
  </KeepAlive>
);
